var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 20V31.6667C35 32.5507 34.6488 33.3986 34.0237 34.0237C33.3986 34.6488 32.5507 35 31.6667 35H8.33333C7.44928 35 6.60143 34.6488 5.97631 34.0237C5.35119 33.3986 5 32.5507 5 31.6667V20H35ZM26.6667 5C27.1087 5 27.5326 5.17559 27.8452 5.48816C28.1577 5.80072 28.3333 6.22464 28.3333 6.66667V8.33333H31.6667C32.5507 8.33333 33.3986 8.68452 34.0237 9.30964C34.6488 9.93476 35 10.7826 35 11.6667V16.6667H5V11.6667C5 10.7826 5.35119 9.93476 5.97631 9.30964C6.60143 8.68452 7.44928 8.33333 8.33333 8.33333H11.6667V6.66667C11.6667 6.22464 11.8423 5.80072 12.1548 5.48816C12.4674 5.17559 12.8913 5 13.3333 5C13.7754 5 14.1993 5.17559 14.5118 5.48816C14.8244 5.80072 15 6.22464 15 6.66667V8.33333H25V6.66667C25 6.22464 25.1756 5.80072 25.4882 5.48816C25.8007 5.17559 26.2246 5 26.6667 5Z",
    fill: "#00BAD3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.cc009731f367a6c0557d3c9a5398f8f2.svg";
export { ForwardRef as ReactComponent };